"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSidebarLink = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../Icon");
const PageSidebarLink = (props) => {
    const { navigationClassName, LinkComponent, linkRoute, iconName, linkSubject, routeKey, isRouteMatch = () => false, } = props;
    const isActive = isRouteMatch(linkRoute || '');
    const isActiveMod = !isActive ? '' : ` ${navigationClassName}__item--active`;
    return (react_1.default.createElement(LinkComponent, { key: `scpsn:route:${routeKey}` },
        react_1.default.createElement("div", { className: `${navigationClassName}__item${isActiveMod}` },
            react_1.default.createElement("div", { className: `${navigationClassName}__icon` },
                react_1.default.createElement(Icon_1.Icon, { name: iconName })),
            react_1.default.createElement("div", { className: `${navigationClassName}__text` }, linkSubject))));
};
exports.PageSidebarLink = PageSidebarLink;
//# sourceMappingURL=index.js.map